import PropTypes from 'prop-types';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Button, Stack } from '@mui/material';
import { PATH_AUTH } from '../routes/paths';

AuthSwitcher.propTypes = {
  sx: PropTypes.object,
};

export default function AuthSwitcher({ sx }) {
  const { pathname } = useLocation();
  const isLogin = pathname.includes('/login');

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mb: 4, ...sx }}>
      <Stack
        direction="row"
        sx={{
          border: '1px solid #3B82F6', // Blue outline
          borderRadius: 3,
          p: 0.5,
          width: '100%',
          maxWidth: 400,
          bgcolor: 'common.white',
        }}
      >
        <Button
          component={RouterLink}
          to={PATH_AUTH.login}
          fullWidth
          sx={{
            py: 1.5,
            borderRadius: 2.5,
            color: isLogin ? 'common.white' : '#3B82F6',
            bgcolor: isLogin ? '#2563EB' : 'transparent',
            '&:hover': {
              bgcolor: isLogin ? '#1D4ED8' : 'rgba(59, 130, 246, 0.08)',
            },
            fontWeight: 'bold',
            textTransform: 'none',
            fontSize: '1rem',
          }}
        >
          Sign In
        </Button>
        <Button
          component={RouterLink}
          to={PATH_AUTH.register}
          fullWidth
          sx={{
            py: 1.5,
            borderRadius: 2.5,
            color: !isLogin ? 'common.white' : '#3B82F6',
            bgcolor: !isLogin ? '#2563EB' : 'transparent',
            '&:hover': {
              bgcolor: !isLogin ? '#1D4ED8' : 'rgba(59, 130, 246, 0.08)',
            },
            fontWeight: 'bold',
            textTransform: 'none',
            fontSize: '1rem',
          }}
        >
          Create An Account
        </Button>
      </Stack>
    </Box>
  );
}
